import React from 'react';
import { motion } from 'framer-motion';
export function CreatorDisclose() {
  return <section className="py-20 md:py-28 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-1717" data-mp="28ouf3ws9xbmq">
      <div className="bg-white rounded-[2.5rem] md:rounded-[3rem] p-8 md:p-16 lg:p-20 border border-neutral-200 shadow-sm" data-id="element-1718" data-mp="28n01z4n8unt7">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-1719" data-mp="1zo5yqvfeqz6o">
          {/* Left Column */}
          <div data-id="element-1720" data-mp="1kz02ngbv9p30">
            <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-[#FCF3EC] text-[#EA580C] text-xs font-bold uppercase tracking-wider mb-6" data-id="element-1721" data-mp="1kz9xbh7uwkf1">
              Required on every post
            </div>
            <h2 className="font-title font-bold text-4xl md:text-5xl tracking-tight text-[#2B211A] mb-6" data-id="element-1722" data-mp="1c04wg48toezp">
              Disclose the partnership
            </h2>
            <div className="space-y-4 text-neutral-600 leading-relaxed text-[15px] md:text-base" data-id="element-1723" data-mp="120xk9kdtqqe6">
              <p data-id="element-1724" data-mp="16zh8jrfw4e9p">
                Every post you submit is a paid partnership, even if you pick
                credits, even if the payout hasn't hit yet, even if your account
                is small. Disclosure is triggered the moment you intend to
                submit, not when the money lands.
              </p>
              <p data-id="element-1725" data-mp="1tuwlg1o3x23e">
                The FTC (US), the ASA / CMA (UK), and every major platform
                require it. Posts without disclosure won't be approved and can't
                be paid out.
              </p>
            </div>
          </div>

          {/* Right Column - Platforms */}
          <div className="space-y-6" data-id="element-1726" data-mp="x55eh2ympmgp">
            {[{
            platform: 'LinkedIn',
            desc: 'Add #ad at the end of your post.'
          }, {
            platform: 'X / Twitter',
            desc: 'Toggle the Paid partnership label in post settings.'
          }, {
            platform: 'Instagram',
            desc: 'Toggle the Paid partnership label in post settings and add #ad to the caption.'
          }, {
            platform: 'YouTube',
            desc: "Turn on 'Includes paid promotion' in YouTube Studio and disclose verbally or on-screen."
          }, {
            platform: 'TikTok',
            desc: "Turn on 'Disclose video content → Brand organic' and add #ad to the caption."
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="border-b border-neutral-100 pb-6 last:border-0 last:pb-0" data-id="element-1727" data-mp="2n8xtzjnf2s8u" data-mpi={i}>
              
                <h4 className="font-bold text-[#2B211A] mb-1" data-id="element-1728" data-mp="24herrf17vi7v">
                  {item.platform}
                </h4>
                <p className="text-neutral-500 text-sm" data-id="element-1729" data-mp="29i2gfu1z3myx">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}